export var StreetHeadingEnum;
(function (StreetHeadingEnum) {
    StreetHeadingEnum["Name"] = "Street name";
    StreetHeadingEnum["AlternativeName"] = "Alternative name";
    StreetHeadingEnum["Type"] = "Type";
    StreetHeadingEnum["Place"] = "Place";
    StreetHeadingEnum["Ward"] = "Ward";
})(StreetHeadingEnum || (StreetHeadingEnum = {}));
